import React from "react";
import "./CallFloat.css";
import { FaPhoneAlt } from "react-icons/fa";

export default function CallFloat() {

  return (

    <a
      href="tel:+254719034500"
      className="zetech-call-float"
      aria-label="Call Zetech University"
    >

      <span className="zetech-call-tooltip">

        Call Us

      </span>

      <FaPhoneAlt />

    </a>

  );

}